<template>
  <div class="container en016">

    <heading-one class="-margin-md">秘密のことば設定</heading-one>

    <errors-alert :errors="errors"></errors-alert>

    <wizard-group class="-margin-md">
      <main-wizard :active-index="1" type="secret"></main-wizard>
    </wizard-group>

    <p>内容をご確認のうえ、よろしければ「設定する」を押してください。</p>

    <form @submit.prevent="submitSecretQuestions()" novalidate>
      <section>

        <table-box class="-entry _mb-30">
          <table-body>
            <table-row>
              <table-header>質問1</table-header>
              <table-data>{{displaySecretWordAsk(userData.secret_word_ask1)}}</table-data>
            </table-row>
            <table-row>
              <table-header>質問1の答え</table-header>
              <table-data>{{userData.secret_word_ans1}}</table-data>
            </table-row>
            <table-row>
              <table-header>質問2</table-header>
              <table-data>{{displaySecretWordAsk(userData.secret_word_ask2)}}</table-data>
            </table-row>
            <table-row>
              <table-header>質問2の答え</table-header>
              <table-data>{{userData.secret_word_ans2}}</table-data>
            </table-row>
            <table-row>
              <table-header>質問3</table-header>
              <table-data>{{displaySecretWordAsk(userData.secret_word_ask3)}}</table-data>
            </table-row>
            <table-row>
              <table-header>質問3の答え</table-header>
              <table-data>{{userData.secret_word_ans3}}</table-data>
            </table-row>
          </table-body>
        </table-box>

        <notice-box class="-point _mb-sm-40 _mb-md-60">
          <notice-body>au PAY スマートローンのご利用にあたって重要な情報となりますので、暗証番号の管理と同様に、お客さまご自身で厳重に管理していただきますようお願します。</notice-body>
        </notice-box>

        <btngroup-single class="_mb-sm-40">
          <btn-main class="-main" @click.prevent="submitSecretQuestions">
            設定する
          </btn-main>
        </btngroup-single>

        <btngroup-single class="-margin-lg">
          <btn-back class="-back -md" routerName="en015">
            修正する
          </btn-back>
        </btngroup-single>

      </section>

    </form>
  </div><!-- container -->
</template>

<script>
import { initCredentials } from '../utils/Auth'
import { submitSecretQuestionsLambdaInvoke, getUserDataLambdaInvoke } from '../utils/LambdaHelper'
import { secretWordAsks } from '../constants/constant'
import HeadingOne from '../components/heading/HeadingOne'
import WizardGroup from '../components/wizard/WizardGroup'
import MainWizard from '../components/wizard/MainWizard'
import ErrorsAlert from '../components/alert/ErrorsAlert'
import TableBox from '../components/tables/TableBox'
import TableBody from '../components/tables/TableBody'
import TableRow from '../components/tables/TableRow'
import TableHeader from '../components/tables/TableHeader'
import TableData from '../components/tables/TableData'
import NoticeBox from '../components/box/NoticeBox'
import NoticeBody from '../components/box/NoticeBody'
import BtngroupSingle from '../components/button/BtngroupSingle'
import BtnMain from '../components/button/BtnMain'
import BtnBack from '../components/button/BtnBack'

export default {
  name: 'En-016',
  metaInfo: {
    title: '秘密のことば設定確認',
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,秘密のことば'}
    ]
  },
  components: {
    BtnBack,
    BtnMain,
    BtngroupSingle,
    NoticeBody,
    NoticeBox,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    ErrorsAlert,
    MainWizard,
    WizardGroup,
    HeadingOne
  },
  data () {
    return {
      errors: {},
      isDisabled: false,
      userData: {
        secret_word_ask1: '',
        secret_word_ans1: '',
        secret_word_ask2: '',
        secret_word_ans2: '',
        secret_word_ask3: '',
        secret_word_ans3: ''
      }
    }
  },
  mounted () {
    try {
      getUserDataLambdaInvoke().then(res => {
        for (let key in res) {
          if (this.userData.hasOwnProperty(key)) {
            this.userData[key] = res[key]
          }
        }
      }).catch(error => {
        this.goToErrorPage(error)
      })
    } catch (e) {
      this.goToErrorPage(e)
    }
  },
  methods: {
    submitSecretQuestions: function (event) {
      try {
        if (this.isDisabled) {
          return
        }
        this.isDisabled = true
        this.errors = {}
        initCredentials().then(res => {
          submitSecretQuestionsLambdaInvoke().then(res => {
            this.errors = res.errors || {}
            if (Object.keys(this.errors).length > 0) {
              this.scrollTop()
              this.isDisabled = false
            } else {
              this.$router.push({name: 'tem021'})
            }
          }).catch(error => {
            this.goToErrorPage(error)
          })
        }).catch(error => {
          this.goToErrorPage(error)
        })
      } catch (e) {
        this.goToErrorPage(e)
      }
    },
    displaySecretWordAsk (target) {
      for (let secretWordAsk of secretWordAsks) {
        if (secretWordAsk.value === target) {
          return secretWordAsk.name
        }
      }
      return ''
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/En016.vue